export const GRID_COLUMNS = {
  firstColumnWidth: 77,
  secondColumnWidth: 600,
  thirdColumnWidth: 160,
  fourthColumnWidth: 70,
  fifthColumnWidth: 185,
  sixthColumnWidth: 180,
  seventhColumnWidth: 'auto',
  eighthColumnWidth: 170,
  ninthColumnWidth: 95,
} as const;

export const rootGridTemplateColumns = {
  gridTemplateColumns: [
    `${GRID_COLUMNS.firstColumnWidth}px`,
    `${GRID_COLUMNS.secondColumnWidth}px`,
    `${GRID_COLUMNS.thirdColumnWidth}px`,
    `${GRID_COLUMNS.fourthColumnWidth}px`,
    `${GRID_COLUMNS.fifthColumnWidth}px`,
    `${GRID_COLUMNS.sixthColumnWidth}px`,
    GRID_COLUMNS.seventhColumnWidth,
    `${GRID_COLUMNS.eighthColumnWidth}px`,
    `${GRID_COLUMNS.ninthColumnWidth}px`,
  ].join(' '),
};

export const getGridTemplateColumns = (depth: number) => {
  const indentWidth = depth * 30;

  if (depth > 0) {
    return {
      gridTemplateColumns: [
        `${GRID_COLUMNS.firstColumnWidth + indentWidth}px`,
        `${GRID_COLUMNS.secondColumnWidth - indentWidth}px`,
        `${GRID_COLUMNS.thirdColumnWidth}px`,
        `${GRID_COLUMNS.fourthColumnWidth}px`,
        `${GRID_COLUMNS.fifthColumnWidth}px`,
        `${GRID_COLUMNS.sixthColumnWidth}px`,
        GRID_COLUMNS.seventhColumnWidth,
        `${GRID_COLUMNS.eighthColumnWidth}px`,
        `${GRID_COLUMNS.ninthColumnWidth}px`,
      ].join(' '),
    };
  }

  return rootGridTemplateColumns;
};
